import { z } from "zod";

export const ChannelNotificationPreferencesSchema = z.object({
  whatsapp: z.boolean(),
  email: z.boolean(),
});
export const ContactSharingPreferencesSchema = z.object({
  whatsapp: z.boolean(),
  email: z.boolean(),
});

// An object rather than a bare boolean even though WhatsApp is the only channel
// these are ever sent on: adding `email` later is then a widening of this shape
// rather than a type change every reader has to follow.
export const EventNotificationPreferencesSchema = z.object({
  whatsapp: z.boolean(),
});

export const ParticipantPreferencesSchema = z.object({
  incomingRequestNotifications: ChannelNotificationPreferencesSchema,
  acceptedRequestNotifications: ChannelNotificationPreferencesSchema,
  contactSharing: ContactSharingPreferencesSchema,
  eventNotifications: EventNotificationPreferencesSchema,
});

export type ParticipantPreferences = z.infer<
  typeof ParticipantPreferencesSchema
>;

export const DEFAULT_PARTICIPANT_PREFERENCES: ParticipantPreferences = {
  incomingRequestNotifications: { whatsapp: true, email: false },
  acceptedRequestNotifications: { whatsapp: true, email: false },
  contactSharing: { whatsapp: true, email: true },
  eventNotifications: { whatsapp: true },
} as const;
